import Sprite from "app/components/sprite";
import { ZBNI_CUSTOMER_SUPPORT } from "app/config/constants";
import { useAnimation } from "app/hooks/useAnimation";
import { useRef } from "react";
import { Trans, useTranslation } from "react-i18next";

export const BenefitsSection = () => {
  const { t: trans } = useTranslation();
  const title = useRef(null);
  const item1 = useRef(null);
  const item2 = useRef(null);
  const item3 = useRef(null);
  const item4 = useRef(null);
  const item5 = useRef(null);

  useAnimation([title, item1, item2, item3, item4, item5]);

  const benefits = [
    {
      icon: "thumbs-up",
      ref: item1,
      description: trans("Enhance your customer experience."),
    },
    {
      icon: "basket-increase",
      ref: item2,
      description: trans("Increase average basket size."),
    },
    {
      icon: "repeat-customers",
      ref: item3,
      description: trans("Increase your repeat customers."),
    },
    {
      icon: "whatsapp-exp",
      ref: item4,
      description: trans("Create a smoother selling experience over WhatsApp."),
    },
    {
      icon: "speech-bubbles",
      ref: item5,
      description: trans("Communicate with your customers more effectively."),
    },
  ];

  return (
    <section className="relative z-10 h-full overflow-hidden bg-white font-montserrat">
      <div className="relative mx-auto max-w-[72rem] px-6 pt-10 md:px-20 md:pt-14">
        <Sprite
          name="donut"
          fill="#F6F6F8"
          className="absolute -left-36 top-8 z-[-1] h-[378px] w-[378px] md:-left-80 md:top-14 md:h-[620px] md:w-[620px]"
        />
        <div className="mb-3 md:mb-8">
          <p
            ref={title}
            data-animation="animate__animated animate__faster animate__fadeInDown"
            className="text-[35px] font-extrabold leading-[42px] text-primary md:text-[45px] md:leading-[54px]"
          >
            <Trans>Benefits</Trans>
          </p>
        </div>
        <div className="flex flex-col gap-3.5 md:gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={`${benefit.icon}-${index}`}
              ref={benefit.ref}
              data-animation={`animate__animated animate__fadeIn animate__delay-${index}s`}
              className="h-[100px] rounded-3xl border border-gray-400 bg-white md:h-[110px]"
            >
              <div className="flex h-full items-center gap-7 px-5 md:gap-11 md:px-8">
                <div>
                  <Sprite
                    name={benefit.icon}
                    className="h-16 w-14 md:h-16 md:w-16"
                  />
                </div>
                <p className="text-sm font-semibold leading-4 md:text-lg md:leading-5">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col items-center gap-2.5 pb-20 pt-14 md:gap-5 md:py-32">
        <div>
          <Sprite
            name="zbooni-call"
            className="h-10 w-14 md:h-[60px] md:w-20"
          />
        </div>
        <p className="max-w-[215px] text-center text-lg font-semibold leading-5 text-primary md:max-w-[290px] md:text-2xl md:font-bold md:leading-7">
          <Trans>Want to talk to someone at Zbooni?</Trans>
        </p>
        <a
          id="cta_collections_chatWithUs"
          href={`${ZBNI_CUSTOMER_SUPPORT}&text=Hello%21%20I%20am%20interested%20in%20learning%20more%20about%20Zbooni.`}
          rel="noreferrer"
          target="_blank"
          className="w-56 rounded-full bg-primary py-3 text-center font-extrabold"
        >
          <span className="bg-gradient-to-r from-yellowgreen to-cyan-dark bg-clip-text text-transparent">
            <Trans>Chat with us</Trans>
          </span>
        </a>
      </div>
    </section>
  );
};
